export default __webpack_public_path__ + "static/Data-Analysis-37769468cf286764b52c4cad8ef02490.png";